module.exports = __webpack_public_path__ + "assets/img/newQuestionsilvermedal@2x.230aa170.png";